export default "__VITE_ASSET__BOVVUP2y__"